/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ESearchFilter,
  InvoiceDto,
  InvoiceDtoPagedResponseDto,
  SortDirection,
  YearsResponse,
} from '../models/index';
import {
    ESearchFilterFromJSON,
    ESearchFilterToJSON,
    InvoiceDtoFromJSON,
    InvoiceDtoToJSON,
    InvoiceDtoPagedResponseDtoFromJSON,
    InvoiceDtoPagedResponseDtoToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
    YearsResponseFromJSON,
    YearsResponseToJSON,
} from '../models/index';

export interface InvoicesGetAvailableYearsGETRequest {
    years?: string;
    orderId?: string;
}

export interface InvoicesGetByIdGETRequest {
    id: string;
}

export interface InvoicesGetInvoicesForSelectedYearsGETRequest {
    orderId?: string;
    selectedYears?: Array<number>;
    searchSearch?: string;
    searchSearchValue?: string;
    searchSearchFilter?: ESearchFilter;
    pagingPageIndex?: number;
    pagingPageSize?: number;
    sortingSortBy?: string;
    sortingSortDir?: SortDirection;
}

/**
 * InvoicesApi - interface
 * 
 * @export
 * @interface InvoicesApiInterface
 */
export interface InvoicesApiInterface {
    /**
     * Creates request options for invoicesGetAvailableYearsGET without sending the request
     * @param {string} [years] 
     * @param {string} [orderId] 
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    invoicesGetAvailableYearsGETRequestOpts(requestParameters: InvoicesGetAvailableYearsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [years] 
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    invoicesGetAvailableYearsGETRaw(requestParameters: InvoicesGetAvailableYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearsResponse>>;

    /**
     */
    invoicesGetAvailableYearsGET(requestParameters: InvoicesGetAvailableYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearsResponse>;

    /**
     * Creates request options for invoicesGetByIdGET without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    invoicesGetByIdGETRequestOpts(requestParameters: InvoicesGetByIdGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    invoicesGetByIdGETRaw(requestParameters: InvoicesGetByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceDto>>;

    /**
     */
    invoicesGetByIdGET(requestParameters: InvoicesGetByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceDto>;

    /**
     * Creates request options for invoicesGetInvoicesForSelectedYearsGET without sending the request
     * @param {string} [orderId] 
     * @param {Array<number>} [selectedYears] 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    invoicesGetInvoicesForSelectedYearsGETRequestOpts(requestParameters: InvoicesGetInvoicesForSelectedYearsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [orderId] 
     * @param {Array<number>} [selectedYears] 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApiInterface
     */
    invoicesGetInvoicesForSelectedYearsGETRaw(requestParameters: InvoicesGetInvoicesForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceDtoPagedResponseDto>>;

    /**
     */
    invoicesGetInvoicesForSelectedYearsGET(requestParameters: InvoicesGetInvoicesForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceDtoPagedResponseDto>;

}

/**
 * 
 */
export class InvoicesApi extends runtime.BaseAPI implements InvoicesApiInterface {

    /**
     * Creates request options for invoicesGetAvailableYearsGET without sending the request
     */
    async invoicesGetAvailableYearsGETRequestOpts(requestParameters: InvoicesGetAvailableYearsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['years'] != null) {
            queryParameters['years'] = requestParameters['years'];
        }

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Invoices/years`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async invoicesGetAvailableYearsGETRaw(requestParameters: InvoicesGetAvailableYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearsResponse>> {
        const requestOptions = await this.invoicesGetAvailableYearsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => YearsResponseFromJSON(jsonValue));
    }

    /**
     */
    async invoicesGetAvailableYearsGET(requestParameters: InvoicesGetAvailableYearsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearsResponse> {
        const response = await this.invoicesGetAvailableYearsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for invoicesGetByIdGET without sending the request
     */
    async invoicesGetByIdGETRequestOpts(requestParameters: InvoicesGetByIdGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invoicesGetByIdGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Invoices/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async invoicesGetByIdGETRaw(requestParameters: InvoicesGetByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceDto>> {
        const requestOptions = await this.invoicesGetByIdGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoicesGetByIdGET(requestParameters: InvoicesGetByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceDto> {
        const response = await this.invoicesGetByIdGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for invoicesGetInvoicesForSelectedYearsGET without sending the request
     */
    async invoicesGetInvoicesForSelectedYearsGETRequestOpts(requestParameters: InvoicesGetInvoicesForSelectedYearsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['selectedYears'] != null) {
            queryParameters['selectedYears'] = requestParameters['selectedYears'];
        }

        if (requestParameters['searchSearch'] != null) {
            queryParameters['Search.Search'] = requestParameters['searchSearch'];
        }

        if (requestParameters['searchSearchValue'] != null) {
            queryParameters['Search.SearchValue'] = requestParameters['searchSearchValue'];
        }

        if (requestParameters['searchSearchFilter'] != null) {
            queryParameters['Search.SearchFilter'] = requestParameters['searchSearchFilter'];
        }

        if (requestParameters['pagingPageIndex'] != null) {
            queryParameters['Paging.PageIndex'] = requestParameters['pagingPageIndex'];
        }

        if (requestParameters['pagingPageSize'] != null) {
            queryParameters['Paging.PageSize'] = requestParameters['pagingPageSize'];
        }

        if (requestParameters['sortingSortBy'] != null) {
            queryParameters['Sorting.SortBy'] = requestParameters['sortingSortBy'];
        }

        if (requestParameters['sortingSortDir'] != null) {
            queryParameters['Sorting.SortDir'] = requestParameters['sortingSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Invoices/yearly`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async invoicesGetInvoicesForSelectedYearsGETRaw(requestParameters: InvoicesGetInvoicesForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceDtoPagedResponseDto>> {
        const requestOptions = await this.invoicesGetInvoicesForSelectedYearsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async invoicesGetInvoicesForSelectedYearsGET(requestParameters: InvoicesGetInvoicesForSelectedYearsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceDtoPagedResponseDto> {
        const response = await this.invoicesGetInvoicesForSelectedYearsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
